(ns machtfit.widgets.shared)

(defn label [{:keys [text]}]
  [:label.text-base.font-bold.text-gray-800
   text])

(defn hint [{:keys [text]}]
  [:span.text-sm.leading-5.text-gray-600
   text])

(defn error [{:keys [text]}]
  [:span.text-sm.leading-tight.text-error-600
   text])
